import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="guide" className="scroll-mt-20 py-10 md:py-14">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.4fr] lg:gap-10">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">HOW TO 蹲帖</span>
            <h2 className="mt-1 text-2xl text-foreground-950 md:text-4xl">蹲帖指南 · 常见问题</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              看不懂「盖楼」「蹲帖」「楼层跟进」？看完这几个问题，就能和楼友一起持续吃瓜、追连瓜不遗漏。
            </p>
            <a
              href="#about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
            >
              了解吃瓜吧
              <i className="ri-arrow-right-line text-sm leading-none" />
            </a>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    open ? "border-primary-300 bg-background-50" : "border-background-200/70 bg-background-100/50"
                  }`}
                >
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-medium text-foreground-900 md:text-base">{f.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} leading-none`} />
                    </span>
                  </button>
                  {open && (
                    <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}